import React from "react";
import { Box, Stack } from "@mui/material";
import ReactECharts from "echarts-for-react";
import VSNTypography from "../../../../shared/VSNTypography";
import { PhysicalOnePagerResultStyle } from "../PhysicalOnePagerResultStyle";
import { chartData, legends1, legends2 } from "./AssessmentConstant";
import { ColoredArrow } from "../../../../shared/icon";
import { EnergyUseChart } from "../../../assessment/CPETChartCommonComponent";

const EnergyUseDuringExercise = ({ data }) => {
  const classes = PhysicalOnePagerResultStyle();

  return (
    <Box>
      <Stack className={classes.assessmentReportCard} gap={4}>
        <VSNTypography fontWeight={700}>
          {data?.description ?? ""}
        </VSNTypography>
        <Box
          sx={{ backgroundColor: "#FFFFFF" }}
          padding={3}
          borderRadius="10px"
        >
          <Stack gap={3}>
            <VSNTypography
              variant="h5"
              fontWeight={700}
              fontSize={{ sm: 24, xs: 20 }}
            >
              {data?.chart_title ?? ""}
            </VSNTypography>
            <Stack direction="row" gap={{ sm: 5, xs: 2 }} flexWrap="wrap">
              <Stack direction="row" gap={{ sm: 2, xs: 1 }} flexWrap="wrap">
                {legends1?.map((item, index) => (
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing="8px"
                    key={index}
                  >
                    <Stack height="auto" width="auto" justifyContent="center">
                      <Box
                        sx={{
                          backgroundColor: item?.color,
                          width: 16,
                          height: 16,
                          borderRadius: "4px",
                        }}
                      />
                    </Stack>
                    <VSNTypography fontSize={{ xs: 14, sm: 16 }}>
                      {item?.label}
                    </VSNTypography>
                  </Stack>
                ))}
              </Stack>
              <Stack
                direction="row"
                gap={{ sm: 2, xs: 1 }}
                flexWrap="wrap"
                mt={{ sm: 0, xs: 2 }}
              >
                {legends2?.map((item, index) => (
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing="8px"
                    key={index}
                  >
                    <Stack height="auto" width="auto" justifyContent="center">
                      <Box
                        sx={{
                          backgroundColor: item?.color,
                          width: 16,
                          height: 16,
                          borderRadius: "4px",
                        }}
                      />
                    </Stack>
                    <VSNTypography>{item?.label}</VSNTypography>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>

          <EnergyUseChart data={data} height="400px" width="100%" />

          <Stack
            direction="row"
            alignItems="center"
            justifyContent={{ xl: "center", xs: "start" }}
            sx={{ overflowX: "auto" }}
          >
            {chartData.map((chart, index) => (
              <Stack
                key={index}
                direction="row"
                alignItems="center"
                className={classes.chartArrowWrapper}
              >
                <Stack
                  className={classes.chartRound}
                  sx={{ backgroundColor: chart.color, color: "#fff" }}
                >
                  {chart.label}
                </Stack>
                {chart.detail && (
                  <Stack
                    sx={{
                      position: "relative",
                      marginLeft: -5,
                    }}
                  >
                    <ColoredArrow color={chart.detailBgColor} />
                    <Stack
                      className={`${classes.chartDetails} detail`}
                      sx={{
                        color: chart.detailTextColor,
                      }}
                    >
                      {chart.detail}
                    </Stack>
                  </Stack>
                )}
              </Stack>
            ))}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default EnergyUseDuringExercise;
